const $ = window.jQuery;
const $window = $(window);
const $html = $('html');
const $body = $('body');


/**
 * Scrolled down header state.
 * Applies a single is--scrolled class on <html>,
 * excluding the homepage which has it all the time
 */

$window.scroll(function () {
  if (!document.body.classList.contains("home")) {
    $html.toggleClass('is--scrolled', $window.scrollTop() > 1);
  }
});


/**
 * Touch screen detection for custom hovers/active states
 */

 if ("ontouchstart" in document.documentElement) {
  $html.addClass('is--touch');
}


/**
 * Temporary hack-workaround for hiding non-default cards until React loads
 * TODO: Something more elegant and effective please
 */

if (window.location.hash) {
  const grid = document.getElementById("js--filter-grid");
  if (grid) {
    grid.classList.add("grid--loading");
  }
}
